import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSectionsConnectedSizeS from './IconSectionsConnected_size_s';

const props: CreateIconArguments = {
  l: IconSectionsConnectedSizeS,
  m: IconSectionsConnectedSizeS,
  s: IconSectionsConnectedSizeS,
  xs: IconSectionsConnectedSizeS,
  name: 'IconSectionsConnected',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
